import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { GlobalAlertComponent } from "./alert/alert.component";
import { GlobalAlertWrapperComponent } from "./wrapper/wrapper.component";
import { PipesModule } from "src/app/shared/pipes/pipes.module";

@NgModule({
  declarations: [
    GlobalAlertComponent,
    GlobalAlertWrapperComponent
  ],
  imports: [
    CommonModule,
    NgbModule,
    PipesModule
  ],
  exports: [
    GlobalAlertComponent,
    GlobalAlertWrapperComponent
  ]
})
export class GlobalAlertsDialogModule { }
